
  const loadProfNamesAutoComplete = (username)=>{
    initLocalState(username)
    return parseIfValid(
      window.localStorage.getItem('profNamesAutoComplete')
    )[username]
  }

  const addSearchingProfName = (username, profName) => {
    const oldProfNames = loadProfNamesAutoComplete(username)
    const oldState = parseIfValid(
      window.localStorage.getItem('profNamesAutoComplete')
    )
    
    if(oldState[username].indexOf(profName)<0){
      const newState = Object.assign(
        {},
        oldState,
        {[username]:[...oldProfNames, profName]}
      )
      window.localStorage.setItem('profNamesAutoComplete', JSON.stringify(newState))
    }
  }

  const initLocalState = (username) => {
    const oldState = parseIfValid(
      window.localStorage.getItem('profNamesAutoComplete')
    )
    if(oldState){
      if(!oldState[username]){
        const newState = Object.assign({}, oldState, {[username]:[]})
        window.localStorage.setItem('profNamesAutoComplete',
          JSON.stringify(newState)
        )
      }
    }
    else{
      const newState = Object.assign({}, {[username]:[]})
      window.localStorage.setItem('profNamesAutoComplete',
        JSON.stringify(newState)
      )
    }
  }

  const parseIfValid = (o)=>{
    return o ? JSON.parse(o) : o
  }

export {loadProfNamesAutoComplete, addSearchingProfName}